import actions from '@/core/store/pedido/documentos/signatarios/actions'

export default {
	actions,
}
